export enum PROPERTY_ATTACHMENT_TYPES {
  APE = 'ape',
  OTHER = 'other',
  CALCOLO_CONORDATO = 'calcolo_concordato',
}
